import styled from 'styled-components';
import { position } from 'styled-system';

const StyledSidebarFooter = styled.footer.attrs(() => ({
	dataTestid: 'sidebar-footer'
	// Every <Button /> will now have type="button" as default
}))`
	width: 100%;
	bottom: 0;
	flex: 0 1 auto;
	${position}
`;

StyledSidebarFooter.defaultProps = {
	position: 'sticky'
};

const SidebarFooter = ({ children, ...rest }) => (
	<StyledSidebarFooter data-testid="sidebar-footer" {...rest}>
		{children}
	</StyledSidebarFooter>
);

export default SidebarFooter;
